<!--活動大廳-->
<template>
	<div class="page-body">
		<div class="activity-top">
			<div class="at-cn">
				<h1>VIP福利</h1>
				<p>温馨提醒：只要達到充值數量就可點擊領取按鈕，領取對應VIP福利</p>
			</div>
		</div>
		<div class="center-wrap">
			<div class="activity-home">
				<div class="cm-card-title">
					<img alt="" class="icon-square" src="@/assets/img-pc/icon5.png">
					<span class="fade-in-right">VIP初級</span>
				</div>
				<ul class="list noselector">
					<li class="card"><img alt="" src="https://api.shengge975.com/upload/1744793462110253.png"
							class="lazy-img bg-img">
						<div class="row1"><span>VIP1</span><span>會員</span><img alt=""
								src="https://api.shengge975.com/upload/1669325077285586.png" class="vip-img"></div>
						<div class="row2">充值需達到 3888.00USDT</div>
						<div class="row3">可領取0.00%福利 3888.00*0=0 USDT</div><!----><!---->
					</li>
					<li class="card color1"><img alt="" src="https://api.shengge975.com/upload/1744793447967115.png"
							class="lazy-img bg-img">
						<div class="row1"><span>VIP2</span><span>會員</span><img alt=""
								src="https://api.shengge975.com/upload/1669325194407765.png" class="vip-img"></div>
						<div class="row2">充值需達到 8888.00USDT</div>
						<div class="row3">可領取0.00%福利 8888.00*0=0 USDT</div><!----><!---->
					</li>
					<li class="card"><img alt="" src="https://api.shengge975.com/upload/1744793433668931.png"
							class="lazy-img bg-img">
						<div class="row1"><span>VIP3</span><span>會員</span><img alt=""
								src="https://api.shengge975.com/upload/1669325226742655.png" class="vip-img"></div>
						<div class="row2">充值需達到 18888.00USDT</div>
						<div class="row3">可領取5.00%福利 18888.00*0.05=944.4 USDT</div><!----><!---->
					</li>
					<li class="card"><img alt="" src="https://api.shengge975.com/upload/1744793419867959.png"
							class="lazy-img bg-img">
						<div class="row1"><span>VIP4</span><span>會員</span><img alt=""
								src="https://api.shengge975.com/upload/166932525829123.png" class="vip-img"></div>
						<div class="row2">充值需達到 38888.00USDT</div>
						<div class="row3">可領取7.00%福利 38888.00*0.07=2722.16 USDT</div><!----><!---->
					</li>
				</ul>
			</div>
			<div class="activity-home">
				<div class="cm-card-title">
					<img alt="" class="icon-square" src="@/assets/img-pc/icon5.png">
					<span class="fade-in-right">VIP中級</span>
				</div>
				<ul class="list noselector">
					<li class="card color1"><img alt="" src="https://api.shengge975.com/upload/1744793406215055.png"
							class="lazy-img bg-img">
						<div class="row1"><span>VIP5</span><span>會員</span><img alt=""
								src="https://api.shengge975.com/upload/166932526716262.png" class="vip-img"></div>
						<div class="row2">充值需達到 88888.00USDT</div>
						<div class="row3">可領取10.00%福利 88888.00*0.1=8888.8 USDT</div><!----><!---->
					</li>
					<li class="card"><img alt="" src="https://api.shengge975.com/upload/1744793392577595.png"
							class="lazy-img bg-img">
						<div class="row1"><span>VIP6</span><span>會員</span><img alt=""
								src="https://api.shengge975.com/upload/1669325276924302.png" class="vip-img"></div>
						<div class="row2">充值需達到 18888.00USDT</div>
						<div class="row3">可領取13.00%福利 18888.00*0.13=2455.44 USDT</div><!----><!---->
					</li>
					<li class="card"><img alt="" src="https://api.shengge975.com/upload/1744793378410029.png"
							class="lazy-img bg-img">
						<div class="row1"><span>VIP7</span><span>會員</span><img alt=""
								src="https://api.shengge975.com/upload/166932533449531.png" class="vip-img"></div>
						<div class="row2">充值需達到 388888.00USDT</div>
						<div class="row3">可領取17.00%福利 388888.00*0.17=66110.96 USDT</div>
						<!----><!---->
					</li>
					<li class="card color1"><img alt="" src="https://api.shengge975.com/upload/1744793365586694.png"
							class="lazy-img bg-img">
						<div class="row1"><span>VIP8</span><span>會員</span><img alt=""
								src="https://api.shengge975.com/upload/166932531429036.png" class="vip-img"></div>
						<div class="row2">充值需達到 588888.00USDT</div>
						<div class="row3">可領取21.00%福利 588888.00*0.21=123666.48 USDT</div>
						<!----><!---->
					</li>
				</ul>
			</div>
			<div class="activity-home">
				<div class="cm-card-title">
					<img alt="" class="icon-square" src="@/assets/img-pc/icon5.png">
					<span class="fade-in-right">VIP高級</span>
				</div>
				<ul class="list noselector">
					<li class="card">
						<img alt="" src="https://api.shengge975.com/upload/1744792998869209.png"
							class="lazy-img bg-img">
						<div class="row1">
							<span>VIP9</span>
							<span>會員</span>
							<img alt="" src="https://api.shengge975.com/upload/1669325324566481.png" class="vip-img">
						</div>
						<div class="row2">充值需達到 888888.00USDT</div>
						<div class="row3">可領取25.00%福利 888888.00*0.25=222222 USDT</div><!----><!---->
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		components: {},
		data() {
			return {};
		},
		mounted() {

		},
		beforeUnmount() {},
		methods: {

		},
	};
</script>
<style lang="scss" scoped>
	.activity-home {
		margin-bottom: 20px;

		.list {
			display: flex;
		}

		.card {
			position: relative;
			width: calc(25% - 18.75px);
			min-height: 142px;
			margin-right: 25px;
			padding: 26px 20px 12px;
			display: flex;
			flex-direction: column;
			justify-content: space-around;
			border-radius: 12px;
			overflow: hidden;
			color: #896623;

			&.color1 {
				color: #fff;
			}

			.row3 {
				margin-top: 20px;
				width: 80%;
			}

			.row1 {
				font-size: 24px;
				font-weight: 800;
				margin-bottom: 10px;
				display: flex;
				align-items: center;

				.vip-img {
					width: 50px;
					height: auto;
				}

				span {
					&:nth-of-type(2) {
						font-weight: 500;
						font-size: 15px;
						margin-left: 5px;
						margin-right: 7px;
						transform: translateY(2px);
					}
				}
			}

			>div {
				position: relative;
				z-index: 5;
				font-size: 12px;
			}

			.bg-img {
				position: absolute;
				z-index: 1;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
			}
		}

		.cm-card-title {
			width: 100%;
			height: 24px;
			margin-bottom: 15px;
			padding: 0 12px;
			font-size: 20px;
			display: flex;
			flex-wrap: nowrap;
			flex-direction: row;
			align-items: center;
			justify-content: normal;

			.icon-square {
				flex: none;
				width: 12px;
				height: 12px;
				margin-right: 4px;
			}

			.fade-in-right {
				height: 24px;
				line-height: 24px;
				margin-right: auto;
				color: #fff;
			}
		}
	}

	.activity-top {
		width: 100%;
		height: 300px;
		position: relative;
		overflow: hidden;
		background: url('~@/assets/img-pc/125.8c66e7ca.jpg') no-repeat;
		background-size: 100% 100%;
		background-color: #0e0f18;
		display: flex;
		flex-direction: column;
		justify-content: center;
		padding: 0 15%;

		h1 {
			font-size: 48px;
			margin-bottom: 17px;
			color: #fff;
			font-weight: 500;
		}

		p {
			font-size: 16px;
			color: #cdcdcd;
		}
	}
</style>